//
// Name
//
export const SHELL_NAME = 'trix-web-shell-classic';